<script setup lang="ts">
import { useQueryClient } from '@tanstack/vue-query'
import LoadingIcon from '~/assets/icons/ui/Loading.svg'

definePageMeta({
  layout: 'unauthenticated',
  auth: false,
})

const { $i18n } = useNuxtApp()
const { formattedFullname } = useAuthorization()
const queryClient = useQueryClient()

useHead({ title: `${$i18n.t('auth.logout.title', { name: formattedFullname.value })} - ${$i18n.t('app.title')}` })

const { status, signOut } = useAuth()
onMounted(() => {
  queryClient.clear()

  if (status.value === 'authenticated') {
    signOut({ redirect: true })
    return
  }
  navigateTo('/auth/login')
})
</script>

<template>
  <TheDataCard
    :title="$t('auth.logout.title', { name: formattedFullname })"
    header-class="bg-gray-200 !justify-center"
    class="max-w-lg mx-auto"
  >
    <div class="flex flex-col justify-center items-center mb-6">
      <div class="h-14 w-14">
        <LoadingIcon class="text-6xl animate-spin" />
      </div>
      <n-divider />
      <p>
        {{ $t('auth.logout.description') }}
      </p>
    </div>
  </TheDataCard>
</template>
